import { TimeRange } from "../../Portfolio/PortfolioEnergyChart/types";
import { startEndDateFromTimeRange } from "../../Portfolio/PortfolioEnergyChart/utils";
import { EnergyHeatmap } from "../../../../features/Charts/Heatmap";
import { MeterMedium, MeterType } from "../../../../services/energyHeatmap";


 const Heatmap = (props: any) => {
    const range = props.timeRange ?? TimeRange.YearToDate;
    const { start, end } = startEndDateFromTimeRange(range);
    
    const mediumFilter:  MeterMedium[] = [MeterMedium.ColdMeter, MeterMedium.ElectricityMeter, MeterMedium.HeatMeter]
    const typeFilter: MeterType[] = [MeterType.FeedIn];

   return <>{ props && <EnergyHeatmap showLegend={props.showLegend} start={start} end={end} objectId={props.id} resourceGroupId={props.resourceGroupId} mediumsFilters={mediumFilter} typeFilters={typeFilter}></EnergyHeatmap>}</>
}

export default Heatmap;